import { COLORS, DSTooltip, DSTooltipProps } from '@repo/design-system/index'
import { QIcon_bell_default } from '@repo/icons/index'
import { subHeaderClassName } from '../../style'

interface SectionTooltipProps {
  text: string
  place: DSTooltipProps['place']
  isMultiline: boolean
  remountFlag: boolean
}

const TextLink = ({ text, place, isMultiline, remountFlag }: SectionTooltipProps) => {
  return (
    remountFlag && (
      <div className="mt-[20px]">
        <p className={subHeaderClassName}>Text Link</p>
        <div className="flex h-[200px] w-[800px] flex-row items-center justify-center">
          <DSTooltip
            place={place}
            triggerComponent={<QIcon_bell_default color={COLORS.PURPLE} />}
            isMultiline={isMultiline}
            contentComponent={text}
            linkComponent={
              <DSTooltip.LinkButton
                onClick={() => {
                  alert('Navigate to another page')
                }}
              >
                Landing
              </DSTooltip.LinkButton>
            }
          />
        </div>
      </div>
    )
  )
}

export default TextLink
